module.exports = __webpack_public_path__ + "static/media/builtinv2-Elektropribori 1.e0cf5b23.png";